const HUBSPOT_APP_ATTR = 'data-hubspot-feedback-hubspot-app';
const getAttribute = attribute => {
  const node = document.querySelector(`script[${attribute}]`);
  if (node) {
    return node.getAttribute(attribute);
  }
  return null;
};
export const isHubspot = Boolean(getAttribute(HUBSPOT_APP_ATTR));